import { render } from "./UserSettingsComponent.vue?vue&type=template&id=6c738d01"
import script from "./UserSettingsComponent.vue?vue&type=script&lang=js"
export * from "./UserSettingsComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__